module.exports = __webpack_public_path__ + "static/media/makeover2.02598abd.jpg";